
import {
  Component,
  Mixins,
  ActionButtonConfig,
  FormPageMixins,
  appConst,
  Watch,
  PageResultModalMixins,
} from "@/lib";
import Productelement from "@/store/modules/shipment/declarecustoms/productelement";
import EditDeclarationElementModel from "./edit-declaration-element.vue";
import CopyDeclarationElementModal  from "./copy-declaration-element.vue"
import { mixins } from "vue-class-component";

@Component({ components: { EditDeclarationElementModel, CopyDeclarationElementModal } })
export default class DeclarationElement extends mixins(FormPageMixins, PageResultModalMixins)  {
  model = new Productelement();
  loading: boolean = false;
  isOpenModify: boolean = false;// 是否打开修改操作
  // 单个申报要素复制操作
  copyDeclarationElement = {
    productCode: "",
    index: -1
  }

  async created() {
    Object.assign(this.config, {
      // getAction: "system/check-point/get",
      labelWidth: 220,
      pageTitleL: "app.CustomsDeclarationElement.Element",
      getAction: "shipment/declarecustoms/getDeclarationElementProductList",
      okAction: "shipment/declarecustoms/updateDeclarationElementProductList",
      isRedirectIndex: false,
    
    });
  }

   saveback() {
    (this.$refs["form-page"] as any).formValidate(async (model: any) => {
      this.loading = true;
      try {
        await this.$store.dispatch({ type: this.config.okAction, data: this.model });;
        
        this.$Message.success(this.L("Tip.SavedSuccessfully"));
        await this.changebutton();
      } finally {
        this.loading = false;
      }
    });
  }
  openModify() {
    this.isOpenModify = true;
  }
   back() {
     this.$router.replace({ name: "declarecustoms.list" });
  }
  async changebutton(){
    await this.$store.dispatch({
      type: "shipment/declarecustoms/getDeclarationElementProductList",
      id: this.model.id,
    });
    this.model = this.$util.assign(this.record) as Productelement;
    this.isOpenModify = false;
  }
//  async submitElement() {
//    await this.$store.dispatch({
//             type: "shipment/declarecustoms/updateDeclarationElementProductSubmitList",
//             data: this.model,
//           });

//     this.model.isHideOk = true;
//   }
  get record() {
    var tt = this.$store.state.shipment.declarecustoms.editProductElement;
    return tt;
  }

  editElement(value, index) {
    this.copyDeclarationElement.productCode = value.productCode;
    this.copyDeclarationElement.index = index;
    this.$store.commit("shipment/declarecustoms/editProductElement", value);
    this.open("edit-declaration-element-model");
  }

  copyItem() {
    this.$router.replace({ name: "declarecustoms.copy", query: { id: this.model.id } });
  }

  async download() {
    this.loading = true;
    let response = await this.$store.dispatch({
      type: "shipment/declarecustoms/exportDeclarationElementForm",
      data: { id: this.model.id },
    });

    this.loading = false;
    let name = response.headers["content-disposition"].split("=")[1];
    this.$util.downloadFile(response.data, decodeURI(name));
  }



    async downloadAll(){
   try {
    this.loading = true;
    let response = await this.$store.dispatch({
      type: "shipment/declarecustoms/exportAllForm",
      data: { id: this.model.id ,formType:'5',officialSeal:'Yes'}
    });
    this.loading = false;
    let name = response.headers["content-disposition"].split("=")[1];
    this.$util.downloadFile(response.data, decodeURI(name));
     } catch (error) {
    }finally{ this.loading = false;}
  }

  // 复制
  copy() {
    this.$store.commit("shipment/declarecustoms/setCopyProductElement", {
      target: this.model.declarationElementProductDtoList
    });
    this.open("copy-declaration-element-modal");
  }

  copySuccess() {
    this.model = this.$util.assign(this.record) as Productelement;
  }

  editSuccess(editModel) {
    let index = this.model.declarationElementProductDtoList.findIndex(e => e.itemIndexNumber == editModel.itemIndexNumber);
    if (index === -1) {
        return;
    }
    let data = this.$util.assign(editModel) as any;
    this.model.declarationElementProductDtoList.splice(index, 1, data);
  }
}
